import { MutableRefObject } from 'react';

export enum AuthState {
  LOADING = 'loading',
  SIGNED_IN = 'signed_in',
  SIGN_IN = 'sign_in',
}

export interface AuthSession {
  username: string;
  // Present only on a signed-in session, decoded from the access token.
  email?: string;
  roles?: string[];
}

export interface AuthProviderState {
  authState: AuthState;
  user: any;
  session: AuthSession | null;
}

export interface AmpAccessToken {
  token: string;
  expiration: Date;
}

export interface AuthProvider {
  getInitialAuthState: () => Promise<AuthProviderState>;
  signIn: (username: string) => Promise<void>;
  signInIdp: (email: string) => Promise<void>;
  signOut: () => void;
  getToken: (force: boolean) => Promise<AmpAccessToken>;
  signInWithWorkspace: (workspace: string, email: string) => Promise<void>;
  signInIdpHelper: (adminUsername: string, email: string) => Promise<void>;
}

export interface AuthCallbacks {
  authState: AuthState;
  loginUsername: string | null;
  loginEmail: string | null;
  loginRoles: string[];
  resetAuthState: () => void;
  signIn: (username: string) => Promise<void>;
  signInIdp: (username: string) => Promise<void>;
  signOut: () => void;

  // preferred way of requesting a token, ensures that an unexpired token is returned
  getToken: (force?: boolean) => Promise<AmpAccessToken>;

  // reference to currently in use access token, useful for iframe components to watch for updates
  accessToken: MutableRefObject<AmpAccessToken | null>;

  // multi-tenant domain methods
  signInWithWorkspace: (workspace: string, email: string) => Promise<void>;
  signInIdpHelper: (adminUsername: string, email: string) => Promise<void>;
}
